module.exports = __webpack_public_path__ + "static/media/5.a550a00c.JPG";